import React from 'react';

const AuthenticationService = () => {
  return (
    <div className="portfolio-project-page">
      <div className="project-content-section">
        <h1>Authentication Microservice</h1>
        <p className="projects-intro">
          Designed and led the modernization of a business-critical authentication microservice, improving its stability, scalability, and transitioning to a stateless architecture.
        </p>

        <p>
          Took full ownership of the service lifecycle – from handling production outages and performance bottlenecks to delivering long-term architectural improvements. 
          Oversaw critical production inquiries, investigated root causes, and implemented resilient caching strategies to ensure service continuity under heavy load and partial outages.
        </p>

        <p>
          One of the key challenges resolved was a recurring deadlock caused by distributed locking in Hazelcast. 
          Refactored the locking logic with safer timeout handling, and offloaded non-critical logic outside of lock scopes to prevent thread exhaustion. 
          These changes significantly improved availability and response times, especially during node instability.
        </p>

        <p>
          Was part of the gradual migration from stateful, session ID–based authentication to a fully stateless OAuth2 model. 
          This architecture was supposed to remove the dependency on central session storage and make the system cloud and microservice friendly.
        </p>

        <p>
          In addition to development work, actively collaborated with internal teams and external teams during integrations, handled escalation cases, and contributed to mentoring and technical decision-making across the platform.
        </p>
      </div>

      {/* Tools and technologies used */}
      <div className="project-content-section tools-section">
        <h2>🛠️ Technologies and Tools</h2>
        <ul>
          <li>Spring Boot</li>
          <li>Hazelcast</li>
          <li>Redis</li>
          <li>EhCache</li>
          <li>OAuth2 / JWT</li>
          <li>OIDC</li>
          <li>PKCE</li>
          <li>REST APIs</li>
          <li>RabbitMQ</li>
        </ul>
      </div>

      {/* Technical deep dive */}
      <div className="project-content-section tools-section">
        <h2>🚀 Technical Implementation</h2>

        <p>
          The caching improvements focused on making Hazelcast more fault-tolerant. Added aggressive failure detection by tuning heartbeat intervals, max no-heartbeat thresholds, and call timeouts. 
          Near Cache was used for fast local reads, and Replicated Maps were evaluated for reduced cluster dependency. Locking logic was redesigned with timeouts and try-lock patterns to prevent system-wide stalls.
        </p>

        <p>
          For authentication flow, introduced a hybrid model with OAuth2 endpoints issuing signed JWTs. Built support for secure access token expiration, refresh token rotation.
        </p>
      </div>
    </div>
  );
};

export default AuthenticationService;
